// Animate in Morris Law logo when scrolling down the home page.
function handleAnimatedHeaderLogo() {
    const container = document.querySelector(
        '[data-selector="splash-container"]',
    );
    const desktopLogo = document.querySelector(
        '[data-selector="desktop-logo"]',
    );
    const mobileLogo = document.querySelector('[data-selector="mobile-logo"]');

    if (!container) {
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    desktopLogo?.setAttribute("data-visible", "false");
                    mobileLogo?.setAttribute("data-visible", "false");
                } else {
                    desktopLogo?.setAttribute("data-visible", "true");
                    mobileLogo?.setAttribute("data-visible", "true");
                }
            });
        },
        { threshold: 0.1 },
    );

    observer.observe(container);
}

// Animate the home page logo sprite.
// It uses a sprite sheet and animates through the frames using CSS transforms.
function handleAnimateHomePageLogo() {
    const sprite = document.querySelector(
        '[data-selector="animated-logo"]',
    ) as HTMLImageElement;

    const restartButton = document.querySelector(
        '[data-selector="animated-logo-restart"]',
    ) as HTMLButtonElement;

    // No sprite on page, so return early.
    if (!sprite) {
        return;
    }

    const preamble = document.querySelector(
        '[data-selector="splash-preamble"]',
    );

    const columns = 10;
    const rows = 17;
    const totalFrames = columns * rows;
    const duration = 5000; // total duration in ms

    let startTime = 0;
    let frameIndex = 0;
    let animationComplete = false;

    function handleAnimationEnd() {
        animationComplete = true;
        preamble?.setAttribute("data-state", "visible");
    }

    function updateFrame(currentTime: number) {
        if (startTime === 0) {
            startTime = currentTime;
        }
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const previousFrameIndex = frameIndex;
        // Don't jump more than one frame at a time.
        frameIndex = Math.min(
            previousFrameIndex + 1,
            Math.floor(progress * (totalFrames - 1)),
        );

        const column = frameIndex % columns;
        const row = Math.floor(frameIndex / columns);

        const translateX = column * -10; // Each frame is 10% wide
        const translateY = row * -(100 / 17); // Each frame is ~5.882% tall

        sprite.style.transform = `translate3d(${translateX}%, ${translateY}%, 0)`;

        if (frameIndex < totalFrames - 1) {
            requestAnimationFrame(updateFrame);
        } else {
            handleAnimationEnd();
        }
    }

    function restartAnimation() {
        // Only allow restart if animation is complete
        if (!animationComplete) {
            return;
        }

        // Reset animation state
        startTime = 0;
        frameIndex = 0;
        animationComplete = false;

        requestAnimationFrame(updateFrame);
    }

    // Only animate the logo if it hasn't been animated before in this session.
    let shouldAnimate = false;
    if (sessionStorage.getItem("splashAnimated") !== "true") {
        shouldAnimate = true;
        sessionStorage.setItem("splashAnimated", "true");
    }

    let started = false;
    function start() {
        if (started) {
            return;
        }
        started = true;
        if (shouldAnimate) {
            requestAnimationFrame(updateFrame);
        } else {
            // Go to the last frame immediately if not animating.
            sprite.style.transform = `translate3d(${-10 * (columns - 1)}%, ${-(100 / rows) * (rows - 1)}%, 0)`;
            animationComplete = true;
            if (preamble) {
                preamble.setAttribute("data-state", "visible");
                preamble.classList.remove("transition-all", "duration-1000");
            }
        }
    }

    // Add double-click event listener to restart animation
    restartButton.addEventListener("click", restartAnimation);

    if (sprite.complete) {
        start();
    }
    sprite.onload = async () => {
        start();
    };
}

export const initHomeLogo = () => {
    handleAnimateHomePageLogo();
    handleAnimatedHeaderLogo();
};
